export default "__VITE_ASSET__Bgsx0g6U__"